import { render, staticRenderFns } from "./ShoppingCartPage.vue?vue&type=template&id=122818c5&"
import script from "./ShoppingCartPage.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartPage.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartPage.vue?vue&type=style&index=0&id=122818c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports